<div>
    <div class="mb-2">
        <div>
            <span class="font-xs info-text">Select Microphone</span>
        </div>
        <telxl-dropdown
            colour="dropdown"
            class="mw-20"
            placeholder="Microphone"
            [outline]="true"
            [menuItems]="mapDevicesToDropdown(microphones())"
            [selected]="micValue()"
            maxHeight="200px"
            (selectedChange)="onMicrophoneChange($event)"
        />
    </div>
    <div class="mb-3">
        <div>
            <span class="font-xs info-text">Select Speakers</span>
        </div>
        <telxl-dropdown
            colour="dropdown"
            class="mw-20"
            placeholder="Speakers"
            [outline]="true"
            [menuItems]="mapDevicesToDropdown(speakers())"
            [selected]="speakerValue()"
            maxHeight="200px"
            (selectedChange)="onSpeakersChange($event)"
        />
    </div>
    <div class="row align-items-center">
        <div class="col-5 font-sm weight-medium">Test Audio</div>
        <audio #testAudio hidden></audio>
        <div class="col-4 ps-1">
            <div class="equalizer pb-0">
                @for (i of bars; track i) {
                    <div
                        class="bar bar-{{ i }}"
                        [style.height.px]="getScaledBarHeight(i)"
                    ></div>
                }
            </div>
            <div class="equalizer flipped pb-0">
                @for (i of bars; track i) {
                    <div
                        class="bar bar-{{ i }}"
                        [style.height.px]="getScaledBarHeight(i)"
                    ></div>
                }
            </div>
        </div>
        <div class="col-3">
            <telxl-button
                colour="dark"
                [outline]="true"
                (buttonClick)="toggleMicTest()"
                size="sm"
            >
                {{ micTestRunning() ? 'Stop test' : 'Test now' }}
            </telxl-button>
        </div>
    </div>
    <div class="row align-items-center audio-playback">
        @if (audioDeviceService.testAudioReady()) {
            <div class="col-5 pe-0">
                <div
                    class="d-flex flex-row align-items-center pb-1 justify-content-between"
                >
                    <div>
                        <span class="font-xs info-text">
                            Audio test playback
                        </span>
                    </div>
                    <div class="mt-1">
                        <button (click)="togglePlayback()" class="audio-btn">
                            <i
                                class="fa-light fa-sm"
                                [ngClass]="isPlaying() ? 'fa-pause' : 'fa-play'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-7 ps-1">
                <div class="progress-container">
                    <div
                        class="progress-bar"
                        [style.width.%]="audioProgress()"
                    ></div>
                </div>
            </div>
        }
    </div>
    <div class="d-flex flex-row pb-3 justify-content-end">
        <div class="flex-shrink">
            <telxl-button
                colour="primary"
                [outline]="true"
                size="md"
                (buttonClick)="save()"
            >
                Save updates
            </telxl-button>
        </div>
    </div>
</div>
